export function validateAnswersCount(questionChoice) {
    const $questionChoice = $(questionChoice);
    const $questionType   = $questionChoice.find('.question-type').val();
    if ('dropdown' === $questionType) {
        setAddNextAnswerButtonDisabled(questionChoice, false);
        return;
    }

    const answersCount    = $questionChoice.find('.answer-list .answer').length;
    const answersLimit    = $('#configMultipleAndSingleTypeAnswerLimit').val() ?? 100;

    if (answersCount >= answersLimit) {
        setAddNextAnswerButtonDisabled(questionChoice, true);
    }

    if (answersCount < answersLimit) {
        setAddNextAnswerButtonDisabled(questionChoice, false);
    }

    if (answersCount > answersLimit) {
        const answerNumberAboveLimit = answersCount - answersLimit;
        removeLastAnswers(questionChoice, answerNumberAboveLimit);
    }
}

function setAddNextAnswerButtonDisabled(questionChoice, disabledStatus) {
    const $questionChoice = $(questionChoice);
    const $addNextAnswerButton = $questionChoice.find('.add-next-answer');
    $addNextAnswerButton.prop('disabled', disabledStatus);
}

function removeLastAnswers(questionChoice, count) {
    const $questionChoice = $(questionChoice);
    const $allAnswers     = $questionChoice.find('.answer-list .answer');
    $allAnswers.slice(-count).toArray().forEach(function (answer) {
        $(answer).find('.answer-remove').trigger('click');
    });
}
